import React, { useState, useEffect } from "react";

export const svg = `<svg width="40" height="40" viewbox="0 0 40 40" viewBox="0 -8 56 80" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.1295 64C21.5517 64 19.5431 61.7908 19.8177 59.2577L21.7684 41.2646C21.8416 40.5891 21.306 40 20.6186 40L5.84593 40C5.16743 40 4.52316 39.7055 4.08373 39.1946L2.55059 37.412C1.84268 36.589 1.81447 35.3885 2.48297 34.5338L29.3207 0.221948C29.4302 0.0819624 29.5992 0 29.7782 0H31.8236C34.4014 0 36.41 2.20917 36.1354 4.74229L34.1847 22.7354C34.1115 23.4109 34.6471 24 35.3345 24H50.1187C50.7906 24 51.4292 24.2887 51.8685 24.7911L53.437 26.5846C54.157 27.4079 54.1899 28.6187 53.5156 29.479L26.6319 63.7785C26.5224 63.9182 26.3537 64 26.1748 64H24.1295Z" fill="url(#blitz-logo-loading-paint0_linear_928_10403)"></path><path d="M20.8119 59.3655L22.7626 41.3724C22.9013 40.0926 21.888 39 20.6186 39L5.84593 39C5.45647 39 5.08985 38.8309 4.84189 38.5426L3.30875 36.76C2.91158 36.2982 2.89622 35.6286 3.27064 35.1499L29.9817 1H31.8236C33.8194 1 35.3503 2.7057 35.1412 4.63451L33.1906 22.6276C33.0518 23.9074 34.0652 25 35.3345 25H50.1187C50.5044 25 50.8678 25.1658 51.1158 25.4494L52.6843 27.2429C53.0883 27.7049 53.1062 28.3803 52.7286 28.8621L25.9716 63H24.1295C22.1337 63 20.6028 61.2943 20.8119 59.3655Z" stroke="url(#blitz-logo-loading-paint1_linear_928_10403)" stroke-width="2"></path><defs><linearGradient id="blitz-logo-loading-paint0_linear_928_10403" x1="45.5281" y1="40.7928" x2="15.7688" y2="15.4673" gradientUnits="userSpaceOnUse"><stop stop-color="#CE0F50"></stop><stop offset="1" stop-color="#FE112D"></stop></linearGradient><linearGradient id="blitz-logo-loading-paint1_linear_928_10403" x1="28" y1="7.2958e-09" x2="28" y2="64" gradientUnits="userSpaceOnUse"><stop stop-color="#FF003D"></stop><stop offset="1" stop-color="#FF003D" stop-opacity="0"></stop></linearGradient></defs></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
